import { Button } from '@mui/material';
import styled from 'styled-components';

import { COLORS, MEDIA } from '../../../theme';

export const PaginationContainer = styled.div`
  display: grid;
  justify-content: start;
  gap: ${({ theme }) => theme.spacing.s3};
  color: ${COLORS.black70};

  grid-template-columns: auto auto auto;
  align-items: center;
  justify-content: start;
  ${MEDIA.mobileDown} {
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
  }
  padding-right: 75px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s1};

  .MuiSvgIcon-root {
    font-size: 24px;
  }
`;

export const ResultsPerPageContainer = styled.div`
  min-width: 144px;
  max-width: 200px;

  &&& .MuiSelect-select {
    color: ${COLORS.black50};
    font-size: ${({ theme }) => theme.fontSize.body2};
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.black20};
  }

  && svg {
    width: 20px;
  }
`;

export const ResultsInfoContainer = styled.div`
  font-size: ${({ theme }) => theme.fontSize.h5};
`;

export const PageButton = styled(Button)`
  &&& {
    width: auto;
    min-width: 32px;
    padding: 0 4px;
  }
`;

export const ArrowButton = styled(Button)`
  &.Mui-disabled {
    svg {
      path {
        fill: ${COLORS.black20};
      }
    }
  }
`;
